export default __webpack_public_path__ + "static/sebastian cygiert-24a8759dc70b2dfc198a751e02598ac8.jpg";